import DynamicDashboard from 'components/DynamicDashboard';
import { Query } from 'hooks/useTableFilters';
import i18n from 'i18n';
import React from 'react';
import ClientsDashboardConfiguration from './DashboardConfiguration';
import { useClientsDashboard } from './useClientsDashboard';

interface DashboardCardsProps {
  filters: Record<string, string>;
  onApplyFilter: () => void;
  setQuery: React.Dispatch<React.SetStateAction<Query>>;
}

const DashboardCards = ({
  filters,
  onApplyFilter,
  setQuery,
}: DashboardCardsProps) => {
  const dashboardProps = useClientsDashboard({ filters });

  return (
    <DynamicDashboard
      filters={filters}
      storageKey="selectedClientsGraphs"
      title={i18n.t('CLIENTS_DASHBOARD_KEY')}
      dashboardModalTitle={i18n.t('CONFIG_CLIENTS_DASHBOARD_MODAL_KEY')}
      getDashboardConfiguration={props => (
        <ClientsDashboardConfiguration filters={filters} {...props} />
      )}
      onApplyFilter={onApplyFilter}
      setQuery={setQuery}
      {...dashboardProps}
    />
  );
};

export default DashboardCards;
